(function () {
  'use strict';
  if (typeof window === 'undefined' || typeof document === 'undefined') return;

  var REDUCE = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function stepSize(rail) {
    var tile = rail.querySelector('.modulo-sg__tile');
    if (!tile) return rail.clientWidth * 0.8;
    var styles = getComputedStyle(rail);
    var gap = parseFloat(styles.columnGap || styles.gap || '16') || 16;
    return tile.getBoundingClientRect().width + gap;
  }

  function updateArrowState(section, rail, prev, next) {
    if (!prev || !next) return;
    var loop = section.getAttribute('data-loop') === '1';
    var atStart = rail.scrollLeft <= 2;
    var atEnd = rail.scrollLeft + rail.clientWidth >= rail.scrollWidth - 2;
    if (loop) {
      prev.disabled = false;
      next.disabled = false;
    } else {
      prev.disabled = atStart;
      next.disabled = atEnd;
    }
  }

  /* Fill grows from 0% → 100% as the rail scrolls. Simple width change — matches
     the product-showcase progress pattern for consistency across sections. */
  function updateProgressThumb(rail, thumb) {
    if (!thumb) return;
    var scrollW = rail.scrollWidth;
    var clientW = rail.clientWidth;
    if (scrollW <= clientW) {
      thumb.style.width = '100%';
      return;
    }
    var maxScroll = scrollW - clientW;
    var scrollPct = maxScroll > 0 ? rail.scrollLeft / maxScroll : 0;
    thumb.style.width = (scrollPct * 100) + '%';
  }

  function scrollByStep(rail, dir) {
    var loop = rail.closest('[data-modulo-sg]').getAttribute('data-loop') === '1';
    var step = stepSize(rail);
    var target = rail.scrollLeft + dir * step;

    if (loop) {
      var max = rail.scrollWidth - rail.clientWidth;
      if (dir > 0 && rail.scrollLeft >= max - 2) {
        rail.scrollTo({ left: 0, behavior: REDUCE ? 'auto' : 'smooth' });
        return;
      }
      if (dir < 0 && rail.scrollLeft <= 2) {
        rail.scrollTo({ left: max, behavior: REDUCE ? 'auto' : 'smooth' });
        return;
      }
    }

    rail.scrollTo({ left: target, behavior: REDUCE ? 'auto' : 'smooth' });
  }

  function attachDrag(rail) {
    var isDown = false, startX = 0, scrollStart = 0, moved = false;

    rail.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'touch') return; /* let native touch scroll handle this */
      isDown = true;
      moved = false;
      startX = e.clientX;
      scrollStart = rail.scrollLeft;
      try { rail.setPointerCapture(e.pointerId); } catch (_) {}
      rail.style.cursor = 'grabbing';
    });

    rail.addEventListener('pointermove', function (e) {
      if (!isDown) return;
      var dx = e.clientX - startX;
      if (Math.abs(dx) > 4) moved = true;
      rail.scrollLeft = scrollStart - dx;
    });

    function end() {
      isDown = false;
      rail.style.cursor = '';
    }

    rail.addEventListener('pointerup', end);
    rail.addEventListener('pointercancel', end);
    rail.addEventListener('pointerleave', end);

    /* Suppress link click after a drag — distinguishes drag from tap */
    rail.addEventListener('click', function (e) {
      if (moved) {
        e.preventDefault();
        e.stopPropagation();
        moved = false;
      }
    }, true);
  }

  function attachAutoplay(section, rail) {
    var interval = parseInt(section.getAttribute('data-interval'), 10) || 6;
    var timer = null;
    var paused = false;

    function tick() {
      if (paused) return;
      var max = rail.scrollWidth - rail.clientWidth;
      var loop = section.getAttribute('data-loop') === '1';
      if (rail.scrollLeft >= max - 2) {
        if (loop) rail.scrollTo({ left: 0, behavior: 'smooth' });
      } else {
        scrollByStep(rail, 1);
      }
    }

    function start() { stop(); timer = window.setInterval(tick, interval * 1000); }
    function stop() { if (timer) { window.clearInterval(timer); timer = null; } }

    section.addEventListener('mouseenter', function () { paused = true; });
    section.addEventListener('mouseleave', function () { paused = false; });
    section.addEventListener('focusin', function () { paused = true; });
    section.addEventListener('focusout', function () { paused = false; });

    /* Pause when section is offscreen to save battery */
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) start();
          else stop();
        });
      }, { threshold: 0.25 });
      io.observe(section);
    } else {
      start();
    }

    /* Pause on tab hidden */
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) stop();
      else start();
    });
  }

  function initSection(section) {
    if (section.__moduloSgInit) return;
    section.__moduloSgInit = true;

    var rail  = section.querySelector('[data-modulo-sg-rail]');
    var prev  = section.querySelector('[data-modulo-sg-prev]');
    var next  = section.querySelector('[data-modulo-sg-next]');
    var thumb = section.querySelector('[data-modulo-sg-thumb]');
    if (!rail) return;

    if (prev) prev.addEventListener('click', function () { scrollByStep(rail, -1); });
    if (next) next.addEventListener('click', function () { scrollByStep(rail, 1); });

    rail.addEventListener('scroll', function () {
      window.requestAnimationFrame(function () {
        updateArrowState(section, rail, prev, next);
        updateProgressThumb(rail, thumb);
      });
    }, { passive: true });

    window.addEventListener('resize', function () {
      updateArrowState(section, rail, prev, next);
      updateProgressThumb(rail, thumb);
    });

    if (section.getAttribute('data-swipe') === '1') {
      attachDrag(rail);
    }

    if (!REDUCE && section.getAttribute('data-autoplay') === '1') {
      attachAutoplay(section, rail);
    }

    updateArrowState(section, rail, prev, next);
    updateProgressThumb(rail, thumb);
  }

  function bootstrap() {
    var sections = document.querySelectorAll('[data-modulo-sg]');
    if (window.moduloLazyInit) {
      window.moduloLazyInit('[data-modulo-sg]', initSection);
    } else {
      for (var i = 0; i < sections.length; i++) initSection(sections[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootstrap);
  } else {
    bootstrap();
  }
})();
